import React from 'react';
import { Button, Row, Tooltip } from 'antd';
import { FormField, maxLength, alphaNumeric, minLength } from 'common';
import styles from './Individuals.module.scss';

const ButtonGroup = Button.Group;
const warn = [minLength(2), maxLength(20), alphaNumeric];

const Individuals: any = ({
  fields,
  meta: { error },
  handleFieldFocus,
}: any) => {
  const addLimit = 10;
  const removeLimit = 1;

  return (
    <>
      {fields.map((individual: any, index: number) => (
        <Row key={index} type="flex" align="bottom">
          <FormField
            onFocus={handleFieldFocus}
            warn={warn}
            label={index === 0 ? 'First Name' : ''}
            name={`${individual}.firstName`}
            className={styles.input}
          />

          <FormField
            onFocus={handleFieldFocus}
            warn={warn}
            label={index === 0 ? 'Last Name' : ''}
            name={`${individual}.lastName`}
            className={
              fields.length - 1 === index
                ? styles.input
                : styles.input__noAddButton
            }
            addonAfter={
              <ButtonGroup>
                <Tooltip title={`Remove Name`}>
                  <Button
                    type="link"
                    size="small"
                    icon="minus"
                    onClick={() => fields.remove(index)}
                    disabled={fields.length === removeLimit}
                  />
                </Tooltip>
                {fields.length - 1 === index && (
                  <Tooltip
                    title={`Add Name Variation (the limit is ${addLimit} variations)`}
                  >
                    <Button
                      type="link"
                      size="small"
                      icon="plus"
                      onClick={() =>
                        fields.push({
                          firstName: '',
                          lastName: '',
                          isExactLastName: false,
                        })
                      }
                      disabled={fields.length >= addLimit}
                    />
                  </Tooltip>
                )}
              </ButtonGroup>
            }
          />

          {/* Temporarily hiding this checkbox with inline style until we gather more info and modify exact name search web service methods */}
          <div style={{ display: 'none' }}>
            <FormField
              key={`${individual}.isExactLastName`}
              inputType="checkbox"
              name={`${individual}.isExactLastName`}
              id={`${individual}.isExactLastName`}
              tooltip="Only return results where last name is an exact match"
            >
              No Variations on Last Name
            </FormField>
          </div>
        </Row>
      ))}
    </>
  );
};

export default Individuals;
